export default __webpack_public_path__ + "static/media/back-cert.73fd6af5.jpg";